import { defineMessages } from 'react-intl';

const messages = defineMessages({
  appTitleAbbr: {
    id: 'appTitleAbbr',
    defaultMessage: 'SLM',
    description: 'Abbreviated application title for Sales Location Management',
  },
  headerNavigationMenu: {
    id: 'headerNavigationMenu',
    defaultMessage: 'Menu',
    description:
      'Button text for menu button on page header to engage navigation menu',
  },
  mainMenu: {
    id: 'mainMenu',
    defaultMessage: 'Main menu',
  },
  selectLanguageTitle: {
    id: 'selectLangaugeTitle',
    defaultMessage: 'Select Language',
    description: 'The title of the language selector panel',
  },
  loginButton: {
    id: 'loginButton',
    defaultMessage: 'Log In',
    description: 'Text on button that logs in the user',
  },
  editButton: {
    id: 'OFC_O1_EDIT_BTN',
    defaultMessage: 'Edit',
    description: 'Text on button or tooltip for button to edit something',
  },
  delete: {
    id: 'delete',
    defaultMessage: 'Delete',
    description: 'Text on button or tooltip for button to delete something',
  },
  hiddenStructureItem: {
    id: 'hiddenStructureItem',
    defaultMessage:
      'Hidden {type,select, SpecialityShop {speciality shop} RangeGroup {range group} SalesLocation {sales location} other {}}',
    description:
      'Tooltip for button to toggle store structure item visibility, showing current status of hidden. Parameter for either Speciality shop or Range Group',
  },
  visibleStructureItem: {
    id: 'visibleStructureItem',
    defaultMessage:
      'Visible {type,select, SpecialityShop {speciality shop} RangeGroup {range group} SalesLocation {sales location} other {}}',
    description:
      'Tooltip for button to toggle store structure item visibility, showing current status of visible. Parameter for either Speciality shop or Range Group',
  },
  loading: {
    id: 'loading',
    defaultMessage: 'Loading...',
  },
  error: {
    id: 'error',
    defaultMessage: 'Error',
  },
  unknownError: {
    id: 'unknownError',
    defaultMessage: 'Unknown error: {message}',
    description:
      'Fallback message when the application encounters an unknown error, with {message} being the English message',
  },
  success: {
    id: 'success',
    defaultMessage: 'Success',
  },
  update: {
    id: 'update',
    defaultMessage: 'Update',
  },
  calculating: {
    id: 'calculating',
    defaultMessage: 'Calculating...',
  },
  notFoundTitle: {
    id: 'notFoundTitle',
    defaultMessage: 'Not Found',
  },
  notFoundBody: {
    id: 'notFoundBody',
    defaultMessage: 'The item could not be found.',
  },
  noResultsTitle: {
    id: 'noResultsTitle',
    defaultMessage: 'No Results',
  },
  noResultsBody: {
    id: 'noResultsBody',
    defaultMessage: 'No results found',
  },
  notImplementedTitle: {
    id: 'notImplementedTitle',
    defaultMessage: 'Not Implemented',
  },
  notImplementedBody: {
    id: 'notImplementedBody',
    defaultMessage: 'This function is not yet implemented.',
  },
  forbiddenTitle: {
    id: 'forbiddenTitle',
    defaultMessage: 'Forbidden',
  },
  forbiddenBody: {
    id: 'forbiddenBody',
    defaultMessage: 'Your account does not have the required permissions.',
  },
  noStoresTitle: {
    id: 'noStoresTitle',
    defaultMessage: 'No Access',
    description:
      'Title of inline message if user has no access to any store in SLM',
  },
  noStoresBody: {
    id: 'noStoresBody',
    defaultMessage: 'Cannot find any store with access for your account',
    description:
      'Body text of inline message if user has no access to any store in SLM',
  },
  noStoreAccessTitle: {
    id: 'noStoreAccessTitle',
    defaultMessage: 'No Access to this Store',
    description:
      'Title of inline message if user has no access to a specific store',
  },
  noStoreAccessBody: {
    id: 'noStoreAccessBody',
    defaultMessage: 'Your account does not have access to this store',
    description:
      'Body text of inline message if user has no access to a specific store',
  },
  selectStoreTitle: {
    id: 'selectStoreTitle',
    defaultMessage: 'Select Store',
  },
  selectStoreBody: {
    id: 'selectStoreBody',
    defaultMessage: 'Please select a store from the Store menu to proceed.',
  },
  selectStorePlaceholder: {
    id: 'selectStorePlaceholder',
    defaultMessage: 'Choose a store, or start typing to filter list',
  },
  mobileSelectStorePlaceholder: {
    id: 'mobileSelectStorePlaceholder',
    defaultMessage: 'Choose a store',
  },
  apply: {
    id: 'apply',
    defaultMessage: 'Apply',
  },
  ok: {
    id: 'ok',
    defaultMessage: 'OK',
  },
  confirm: {
    id: 'confirm',
    defaultMessage: 'Confirm',
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel',
  },
  yes: {
    id: 'yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'no',
    defaultMessage: 'No',
  },
  close: {
    id: 'close',
    defaultMessage: 'Close',
  },
  unassign: {
    id: 'unassign',
    defaultMessage: 'Unassign',
    description: 'Button label to remove an article from a sales location',
  },
  submit: {
    id: 'submit',
    defaultMessage: 'Submit',
    description: 'Button label to submit a form or search query',
  },
  search: {
    id: 'search',
    defaultMessage: 'Search',
  },
  save: {
    id: 'save',
    defaultMessage: 'Save',
  },
  reset: {
    id: 'reset',
    defaultMessage: 'Reset',
    description: 'Reset form to initial state',
  },
  retry: {
    id: 'retry',
    defaultMessage: 'Retry',
    description: 'Retry operation',
  },
  articleNumber: {
    id: 'articleNumber',
    defaultMessage: 'Art. No.',
    description: 'Article Number, abbreviated',
  },
  articleNumberTooltip: {
    id: 'articleNumberTooltip',
    defaultMessage: 'Article Number',
  },
  articleName: {
    id: 'articleName',
    defaultMessage: 'Art. Name',
    description: 'Article Name, abbreviated',
  },
  articleNameTooltip: {
    id: 'articleNameTooltip',
    defaultMessage: 'Article Name',
  },
  description: {
    id: 'description',
    defaultMessage: 'Description',
  },
  noDescription: {
    id: 'noDescription',
    defaultMessage: '[No description]',
  },
  resetToDefault: {
    id: 'resetToDefault',
    defaultMessage: 'Reset to default',
  },
  genericErrorTitle: {
    id: 'genericErrorTitle',
    defaultMessage: 'An error occurred',
  },
  genericErrorMessage: {
    id: 'genericErrorMessage',
    defaultMessage: 'The application encountered an error.',
  },
  searchResults: {
    id: 'searchResults',
    defaultMessage: 'Search results',
  },
  on: {
    id: 'on',
    defaultMessage: 'On',
    description: 'Indicates an on state',
  },
  off: {
    id: 'off',
    defaultMessage: 'Off',
    description: 'Indicates an off state',
  },
  print: {
    id: 'print',
    defaultMessage: 'Print',
  },
  next: {
    id: 'next',
    defaultMessage: 'Next',
  },
  previous: {
    id: 'previous',
    defaultMessage: 'Previous',
  },
  atStart: {
    id: 'atStart',
    defaultMessage: 'At start',
  },
  atEnd: {
    id: 'atEnd',
    defaultMessage: 'At end',
  },
  storeMenu: {
    id: 'storeMenu',
    defaultMessage: 'Store menu',
  },
  storeMenuTitle: {
    id: 'storeMenuTitle',
    defaultMessage: 'Store selection menu',
    description: 'Tooltip for Store menu button',
  },
  authenticating: {
    id: 'authenticating',
    defaultMessage: 'Authenticating...',
  },
  authenticationFailed: {
    id: 'authenticationFailed',
    defaultMessage: 'Authentication failed',
  },
  store: {
    id: 'store',
    defaultMessage: 'Store',
    description:
      'The generic word for store, referring to the business unit being managed',
  },
  chooseStore: {
    id: 'chooseStore',
    defaultMessage: 'Choose store',
  },
  storeListLoadError: {
    id: 'storeListLoadError',
    defaultMessage: 'Failed to load store list',
  },
  topic: {
    id: 'topic',
    defaultMessage: 'Topic',
  },
  date: {
    id: 'date',
    defaultMessage: 'Date',
  },
  when: {
    id: 'when',
    defaultMessage: 'When',
  },
  helpTitle: {
    id: 'helpTitle',
    defaultMessage: 'Help',
  },
  helpText: {
    id: 'helpText',
    defaultMessage: 'Help text',
  },
  storeStructureLoadingError: {
    id: 'storeStructureLoadingError',
    defaultMessage:
      'There was a problem loading the Store information. Please try again later.',
  },
  openChangeHistory: {
    id: 'openChangeHistory',
    defaultMessage: 'Open change history',
  },
  emptyHistory: {
    id: 'emptyHistory',
    defaultMessage: 'Empty History',
    description:
      'Text instead of tabular data when there is a lack of historic data',
  },
  historyLoadingError: {
    id: 'historyLoadingError',
    defaultMessage: 'Failed to load history',
  },

  cookieConsentPopupTitle: {
    id: 'cookieConsentPopupTitle',
    defaultMessage: 'Cookie Policy',
    description:
      'Header on popup for Cookie policy, for users who have not taken an active decision on cookie consent',
  },
  cookieConsentPopupBodyText: {
    id: 'cookieConsentPopupBodyText',
    defaultMessage:
      'This site uses cookies to function. Additional cookies allows for usage statistics used to improve the application.',
    description: 'Body text on popup for Cookie policy',
  },
  cookieConsentPopupAllowStatisticsButton: {
    id: 'cookieConsentPopupAllowStatisticsButton',
    defaultMessage: 'Allow statistics',
    description:
      'Popup for Cookie Policy. Button for only allowing statistics.',
  },
  cookieConsentPopupEssentialButton: {
    id: 'cookieConsentPopupEssentialButton',
    defaultMessage: 'Essential only',
    description:
      'Popup for Cookie Policy. Button for only allowing essential cookies.',
  },
  cookieConsentRestartNeeded: {
    id: 'cookieConsentRestartNeeded',
    defaultMessage: 'Page reload needed to fully disable statistics',
    description:
      'Help message on disabling statistics that the page needs to be refreshed/reloaded to fully disable',
  },
  cookieConsentPendoPrivacyStatement: {
    id: 'cookieConsentPendoPrivacyStatement',
    defaultMessage: 'Pendo Privacy Statement',
    description:
      'Text for link to the Privacy Statement for Pendo. Pendo is a trademark.',
  },

  privacyPolicyPanelHeader: {
    id: 'privacyPolicyPanelHeader',
    defaultMessage: 'Privacy Policy',
    description: 'Header on panel for privacy policy',
  },

  appTitle: {
    id: 'appTitle',
    defaultMessage: 'Sales Location Management',
  },
  maintainTitle: {
    id: 'maintainTitle',
    defaultMessage: 'O11 Maintain Sales Location',
  },
  storeStructureTitle: {
    id: 'storeStructureTitle',
    defaultMessage: 'O12 Sales Location Structure',
  },
  parametersTitle: {
    id: 'parametersTitle',
    defaultMessage: 'O14 Parameters',
  },
  summariesTitle: {
    id: 'summariesTitle',
    defaultMessage: 'O16 Summaries',
  },
  importTitle: {
    id: 'importTitle',
    defaultMessage: 'O17 Import',
  },
  serviceOfficeTitle: {
    id: 'serviceOfficeTitle',
    defaultMessage: 'Service Office',
  },
  userManagementTitle: {
    id: 'userManagementTitle',
    defaultMessage: 'User Management',
  },
  devToolsTitle: {
    id: 'devToolsTitle',
    defaultMessage: 'DevTools',
    description:
      'Developer Tools menu item. Note: does not need to be translated.',
  },
  itemComputerTitle: {
    id: 'itemComputerTitle',
    defaultMessage: 'Item Computer',
    description: 'Item Computer heading. Note: does not need to be translated.',
  },
  actionTitle: {
    id: 'actionTitle',
    defaultMessage: 'Action',
    description: 'Assignment Action heading',
  },
  actionsTitle: {
    id: 'actionsTitle',
    defaultMessage: 'Actions',
  },

  noArticleTitle: {
    id: 'noArticleTitle',
    defaultMessage: 'Article not found',
  },
  noArticleBody: {
    id: 'noArticleBody',
    defaultMessage: 'No article found for this article number.',
  },
  paginationTotalNumberArticles: {
    id: 'paginationTotalNumberArticles',
    defaultMessage: 'Total number of articles:',
    description:
      'Indicates how many articles have been found by the search query',
  },

  empty: {
    id: 'empty',
    defaultMessage: 'Empty',
  },

  details: {
    id: 'details',
    defaultMessage: 'Details',
  },
  errorOccurred: {
    id: 'errorOccurred',
    defaultMessage: 'An error has occurred',
    description: 'Generic fallback error message',
  },

  weekPrefix: {
    id: 'weekPrefix',
    defaultMessage: 'W',
    description: 'Prefix denoting the week number. E.g. W52, W01, etc.',
  },

  sunday: {
    id: 'sunday',
    defaultMessage: 'Sunday',
  },
  monday: {
    id: 'monday',
    defaultMessage: 'Monday',
  },
  tuesday: {
    id: 'tuesday',
    defaultMessage: 'Tuesday',
  },
  wednesday: {
    id: 'wednesday',
    defaultMessage: 'Wednesday',
  },
  thursday: {
    id: 'thursday',
    defaultMessage: 'Thursday',
  },
  friday: {
    id: 'friday',
    defaultMessage: 'Friday',
  },
  saturday: {
    id: 'saturday',
    defaultMessage: 'Saturday',
  },

  dateTime: {
    id: 'dateTime',
    defaultMessage: 'Date/Time',
  },
  userName: {
    id: 'userName',
    defaultMessage: 'User name',
  },

  name: {
    id: 'name',
    defaultMessage: 'Name',
    description: 'Generic name text for the naming of things',
  },

  valueAtNightBatch: {
    id: 'valueAtNightBatch',
    defaultMessage: 'At night batch',
    description: 'Message indicating a value was accurate at night batch',
  },

  selectSingleFileButton: {
    id: 'selectSingleFileButton',
    defaultMessage: 'Select {extension} file',
    description:
      'Button label for single file selection with {extension} being the filename extension.',
  },
  selectMultipleFilesButton: {
    id: 'selectMultipleFilesButton',
    defaultMessage: 'Select {extension} files',
    description:
      'Button label for multiple file selection with {extension} being the filename extension.',
  },

  statusCode501Title: {
    id: 'statusCode501Title',
    defaultMessage: 'Not Implemented',
    description: 'Error title for functionality that is not implemented.',
  },
  statusCode501Body: {
    id: 'statusCode501Body',
    defaultMessage: 'This functionality is not implemented.',
    description: 'Error message for functionality that is not implemented.',
  },
  choseAnAptionHint: {
    id: 'choseAnAptionHint',
    defaultMessage: 'Choose an option',
    description:
      'Used in dropdown menus to indicate that an option must be chosen',
  },
  keepEditing: {
    id: 'keepEditing',
    defaultMessage: 'Keep editing',
    description:
      'Button label to dismiss a discard-changes prompt and continue editing',
  },
  signOut: {
    id: 'signOut',
    defaultMessage: 'Sign Out',
    description: 'Button label to log out of the application',
  },
  mupQtyPalQty: {
    id: 'mobileMaintainMupQtyPalQty',
    defaultMessage: 'MupQty(PalQty)',
    description:
      'Label showing multipack quantity (MupQty) and pallet quantity (PalQty)',
  },

  switchToDesktop: {
    id: 'switchToDesktop',
    defaultMessage: 'Switch to Desktop',
    description: 'Button on mobile to change view to Desktop interface',
  },
  switchToMobile: {
    id: 'switchToMobile',
    defaultMessage: 'Switch to Mobile',
    description: 'Button on desktop to change view to Mobile interface',
  },
});

export default messages;
